import apiService from './api'

export const { list, show } = apiService('/articles');